import React, { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import loadComponent from 'src/utils/loadMFE'
import { ApiKey } from 'types/gateway'
import RouteContainer from 'src/components/App/RouteContainer'

const ApiKeyCreateForm = React.lazy(() => loadComponent('api_gateway', 'ApiKeyCreateForm'))

export function ApiKeyCreateRoute() {
    const navigate = useNavigate()

    const onCreate = useCallback(
        (apiKey: ApiKey) => {
            navigate(`/settings/apikeys/${apiKey._id}`)
        },
        [navigate],
    )

    return (
        <RouteContainer>
            <ApiKeyCreateForm onCreated={onCreate} />
        </RouteContainer>
    )
}
